import { VendorSalesRep } from './vendorSalesRep.model';

export const vendorManagement = {
  vendorSalesRep: {
    byCpmsId: getVendorDropdownByCpmsId,
  },
};

/**
 * Returns a query to find vendor sales rep based on a list of cpms IDs
 *
 * @param ids a list of IDs in a string format
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function getVendorDropdownByCpmsId(ids?: string) {
  return `SELECT CPMS_ID__c,Name,Vendor_Group__c FROM Vendor_Group_Member__c WHERE CPMS_ID__c IN (${ids}) AND CPMS_ID__c NOT IN ('')`;
}
